import { Empty as AntEmpty } from 'antd'
import * as React from 'react'

const Empty: React.FC<React.ComponentProps<typeof AntEmpty>> = (props) => {
  return <AntEmpty image={AntEmpty.PRESENTED_IMAGE_SIMPLE} {...props} />
}

export default Empty
